const STATUS_COLORS = { pending: "warning", confirmed: "success", canceled: "error", abandoned: "gray" };

const PAYMENT_STATUS_COLORS = { comp: "blue", paid: "success", unpaid: "gray", refund_processing: "warning", refunded: "gray", disputed: "error" };

export const registrationStatusBadge = (registration) => ({
  color: STATUS_COLORS[registration.status] || "gray",
  label: registration.status_label,
});

export const registrationPaymentBadge = (registration) => ({
  color: PAYMENT_STATUS_COLORS[registration.payment_status] || "gray",
  label: registration.payment_status_label,
});
